import { object, number, string } from 'yup'

const exemplarSchema = object().shape({
  formato_exemplar_id: number()
    .typeError('Valor inválido!')
    .required('Campo obrigatório'),
  biblioteca_id: number()
    .typeError('Valor inválido!')
    .required('Campo obrigatório'),
  status_exemplar_id: number()
    .typeError('Valor inválido!')
    .required('Campo obrigatório'),
  observacao: string()
    .min(6, 'Mínimo de caracteres não atendido!')
    .max(300, 'Limite de caracteres ultrapassado!'),

  quantidade: number()
    .typeError('Valor inválido!')
    .min(1, 'O Valor deve estar entre 1 e 10')
    .max(10, 'O Valor deve estar entre 1 e 10')
})

export default exemplarSchema
